import { useAuth } from './AuthProvider'
import { Navigate } from 'react-router-dom'
import { LoadingSpinner } from '../shared/LoadingSpinner'

interface ProtectedRouteProps {
  children: React.ReactNode
  redirectTo?: string
}

export function ProtectedRoute({ children, redirectTo = '/' }: ProtectedRouteProps) {
  const { isSignedIn, loading } = useAuth()

  if (loading) {
    return <LoadingSpinner fullScreen size="xl" variant="minimal" />
  }

  if (!isSignedIn) {
    return <Navigate to={redirectTo} replace />
  }

  return <>{children}</>
}
